import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReferralMessage } from '@principle-theorem/principle-core';
import {
  IReferral,
  IReferralMessage,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef, isWithRef } from '@principle-theorem/shared';
import { ReferralService } from './referral.service';

@Injectable()
export class ReferralMessageService {
  private _referralService = inject(ReferralService);
  private _snackBar = inject(MatSnackBar);

  async upsert(
    referral: WithRef<IReferral>,
    message: IReferralMessage | WithRef<IReferralMessage>
  ): Promise<void> {
    const saveStartTime = this._referralService.startSaving();
    try {
      if (isWithRef(message)) {
        await Firestore.patchDoc(message.ref, { ...message });
      } else {
        await Firestore.addDoc(ReferralMessage.col(referral), { ...message });
      }

      await this._referralService.updateLastActivityBy(referral, message.actor);
    } catch {
      this._snackBar.open('Error with referral message operation');
    } finally {
      await this._referralService.stopSaving(saveStartTime);
    }
  }
}
